export interface ILogger {
    log(message: string): void;
    warning(message: string): void;
    verbose(message: string): void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error(message: any | string | Error): void;
    withPrefix(prefix: string): ILogger;
}

class BuildAction {
    private readonly logger: ILogger;
    private readonly start: Date;
    private readonly actionName?: string;

    public constructor(start: Date, logger: ILogger, actionName?: string) {
        this.start = start;
        this.logger = logger;
        this.actionName = actionName;
        this.logger.log(`${actionName || ""} started.`);
    }

    public complete(): void {
        const durationMillis = new Date().getTime() - this.start.getTime();
        this.logger.log(`${this.actionName || ""} complete in ${Math.round(durationMillis / 1000)}s`);
    }
}

export function buildActionBegin(logger: ILogger, actionName?: string): BuildAction {
    return new BuildAction(new Date(), logger, actionName);
}
